import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/React-Components/React-Components/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-components"
    }}>{`React-Components`}</h1>
    <p>{`A library of common React components used throughout our applications.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p><inlineCode parentName="p">{`yarn add upe-react-components@https://github.com/BUUPE/React-Components.git#dist`}</inlineCode>{`
or
`}<inlineCode parentName="p">{`npm install --save upe-react-components@https://github.com/BUUPE/React-Components.git#dist`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      